/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { IPopupOptions } from './IPopupModal';
import ClassUtil from '../../ClassUtil';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Class for configuring popup ui components. */
@cc._decorator.ccclass
export default class PopupData extends cc.Component implements IPopupOptions
{
    public ReferenceTag: number = 0;

    public static readonly DefaultOkButtonText: string = 'Menu/OK';
    public static readonly DefaultCancelButtonText: string = 'Menu/Cancel';

    public MessageId: string = null;

    /** Top title label */
    @property(cc.Label)
    protected titleLabel: cc.Label = null;
    /** Setter for applying title to ui. */
    public set Title(value: string) { if (this.titleLabel) { this.titleLabel.string = value; }}

    /** X button */
    @property(cc.Button)
    protected exitButton: cc.Button = null;

    /** Message display label */
    @property(cc.Label)
    protected messageLabel: cc.Label = null;
    /** Setter for applying message to ui. */
    public set Message(value: string)
    {
        if (this.messageLabel)
        {
            this.messageLabel.string = value;
            this.messageLabel.node.active = !!value;
        }
    }

    /** Button for positive confirmation. */
    @property(cc.Node)
    protected okButton: cc.Node = null;

    /** Whether button is visible. */
    public set IncludeOkButton(value: boolean) { if (this.okButton) { this.okButton.active = value; } }
    /** Label string value for positive confirmation.  */
    public set OkButtonText(value: string)
    {
        if (this.okButton)
        {
            let label: cc.Label = this.okButton.getComponentInChildren(cc.Label);

            if (!label) { return; }

            label.string = value;
        }
    }
    /** Function to execute on positive confirmation. */
    public FnOnOK: () => any = null;

    /** Button for cancellation. */
    @property(cc.Node)
    protected cancelButton: cc.Node = null;
    /** Whether cancellation button visible. */
    public set IncludeCancelButton(value: boolean) { if (this.cancelButton) { this.cancelButton.active = value; } }
    /** Label string value for cancellation.  */
    public set CancelButtonText(value: string)
    {
        if (this.cancelButton)
        {
            let label: cc.Label = this.cancelButton.getComponentInChildren(cc.Label);

            if (!label) { return; }

            label.string = value;
        }
    }
    /** Function to execute on cancellation. */
    public FnOnCancel: () => any = null;

    /** @hidden */
    protected onLoad(): void
    {
        this.configureButtonHandlers();
    }

    /** Hooks up buttons to respective handlers. */
    private configureButtonHandlers(): void
    {
        let okEventHandler: cc.Component.EventHandler = new cc.Component.EventHandler();
        okEventHandler.target = this.node;
        okEventHandler.component = ClassUtil.getName(PopupData);
        okEventHandler.handler = "FnOnOK";
        okEventHandler.customEventData = this.node.uuid;

        this.okButton.getComponentInChildren(cc.Button).clickEvents.push(okEventHandler);

        let cancelEventHandler: cc.Component.EventHandler = new cc.Component.EventHandler();
        cancelEventHandler.target = this.node;
        cancelEventHandler.component = ClassUtil.getName(PopupData);
        cancelEventHandler.handler = "FnOnCancel";
        okEventHandler.customEventData = this.node.uuid;

        this.cancelButton.getComponentInChildren(cc.Button).clickEvents.push(cancelEventHandler);
        this.exitButton.clickEvents.push(cancelEventHandler);
    }
}
